import { ReactNode } from 'react'
import type { ParseKeys } from 'i18next'
import { useTranslation } from 'next-i18next'
import Link from 'next/link'
import { twMerge } from 'tailwind-merge'
import { useIsActive } from 'modules/header/hooks/use-is-active'

export function TopMenuItem({
  icon,
  name,
  href,
  ignoreBasePath = false,
  className,
  activeClassName,
  ...rest
}: {
  icon: ReactNode
  name: ParseKeys
  href: string
  ignoreBasePath?: boolean
  className?: string
  activeClassName?: string
}): ReactNode {
  const isActive = useIsActive(href)
  const { t } = useTranslation()

  const classes = twMerge(
    'hidden h-full items-center gap-2 border-b-4 border-transparent text-sm font-bold text-background-secondary lg:flex',
    className,
    isActive && twMerge('border-brand-primary text-background-secondary', activeClassName),
  )

  if (ignoreBasePath) {
    return (
      <a href={href} className={classes} {...rest}>
        {icon}
        <span className="mt-1">{t(name)}</span>
      </a>
    )
  }

  return (
    <Link href={href} className={classes} {...rest}>
      {icon}
      <span className="mt-1">{t(name)}</span>
    </Link>
  )
}
